import React from 'react';
import {
  Box,
  Container,
  Title,
  Text,
  Stack,
  List,
  Breadcrumbs,
  Divider,
} from '@mantine/core';
import Link from '../Link';
import TwizLogo from '../TwizLogo';
import HomePageFooter from '../HomePageFooter';
import { HeroBackground } from '../HomePageBackground';
import { randomString } from '../../utils';

const assignKeys = (sections) => (
  sections.map(({ title, subheading, bullets }) => ({
    key: randomString(),
    title,
    subheading,
    bullets: bullets.map((bullet) => ({
      key: randomString(),
      content: bullet,
    }))
  }))
);

function TermsPrivacyPageTemplate(props){

  const { content } = props;
  const sections = assignKeys(content.sections);
  const wrapperWidthFix = { itemWrapper: { width: 'calc(100% - 24px)' }};

  const getBreadrumbs = () => {
    const { breadcrumb, href } = content;

    const items = [
      { title: 'Home', href: '/' },
      { title: breadcrumb, href },
    ];
    
    return items.map((item) => (
      <Link href={item.href} key={randomString()}>
        {item.title}
      </Link>
    ));
  }

  return (
    <Box>
      <HeroBackground>
        <Container px='xl' pt={{ base: 'xl', md: 56 }}>
          <TwizLogo />
          <Breadcrumbs separator={<Text c='gray.5'>/</Text>} fz='sm' mt='md'>{getBreadrumbs()}</Breadcrumbs>
          <Title mt='md' mb='xs'>{content.title}</Title>
          <Text size='sm' c='dimmed'>Last updated {content.lastUpdated}</Text>
        </Container>
      </HeroBackground>
      <Container p='xl' pb={56}>
        <Stack>
          
          <Divider color='gray.2' my='sm' />
          
          {content.subheading}

          <List type='ordered' spacing='lg' mt='sm' styles={wrapperWidthFix}>
            {sections.map((section) => (
              <List.Item key={section.key} fz='lg'>
                
                <Title order={4} mb='xs'>
                  {section.title}
                </Title>

                { section.subheading &&
                  <Text fz='md' mb='xs'>
                    {section.subheading}
                  </Text>
                }

                { section.bullets?.length >= 1 &&
                  <List
                    withPadding={section.subheading?.length > 1}
                    spacing='xs'
                    styles={wrapperWidthFix}
                  >
                    {section.bullets.map((bullet) => <List.Item key={bullet.key}>{bullet.content}</List.Item>)}
                  </List>
                }

              </List.Item>
            ))}
          </List>
        </Stack>
      </Container>
      <HomePageFooter />
    </Box>
  );

};

export default TermsPrivacyPageTemplate;